import type { Customer } from 'src/interfaces/customer'
import { resolveCustomerDisplayName } from 'src/utils/customerList'

/** Partner id → display name, for endpoints that return only `partnerId`. Memoize the result. */
export const buildPartnerNameMap = (customers: Customer[]): Record<string, string> => {
  return customers.reduce<Record<string, string>>((nameMap, customer) => {
    return { ...nameMap, [customer.id]: resolveCustomerDisplayName(customer) }
  }, {})
}

/**
 * A name the row already carries wins; then the lookup; then the raw id, so an unknown partner is
 * still identifiable rather than blank.
 */
export const resolvePartnerName = (
  nameMap: Record<string, string>,
  partnerId?: string | null,
  knownName?: string | null,
): string => {
  if (knownName) {
    return knownName
  }

  if (!partnerId) {
    return '—'
  }

  return nameMap[partnerId] ?? partnerId
}
